const { debounce, translateString, getElement, getElements } = window.BAO.utils
const { ProductCard } = window.BAO.Tagalys
class TagalysSearch extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['inner', 'skeleton', 'empty']
  }

  connectedCallback () {
    super.connectedCallback()
    this.detailsStates = {}
    this.filterDrawerOpen = false
  }

  setupListeners () {
    super.setupListeners()

    if (!this.searchTerm?.length) {
      this.els.skeleton.element.setAttribute('aria-hidden', 'true')
      this.els.empty.element.setAttribute('aria-hidden', 'false')
      return
    }

    if (!window?.onTagalysReady) return

    // eslint-disable-next-line no-undef
    onTagalysReady(this.initialise.bind(this))
  }

  initialise () {
    // eslint-disable-next-line no-undef
    Tagalys.UIWidgets.SearchResults.init(this.localName, {
      // params: {},
      templates: {
        widget: {
          options: {
            canAppendQueryStringToUrl: true,
            limit: 48,
            includeTagalysCSS: false,
          },
          render: this.renderSearchResults.bind(this),
        },
        loader: {
          render: this.renderLoader.bind(this),
        },
        body: {
          render: this.renderBody.bind(this),
        },
        noResults: {
          options: {
            widgets: [
              {
                widgetId: '3944f454ac50dafc224c',
                options: {
                  templates: {
                    widget: {
                      options: {
                        includeTagalysCSS: false,
                        displayFormat: 'grid',
                      },
                      render: (html, args) => {
                        const { templates, props } = args
                        const { helpers } = props
                        const products = helpers.getProducts()

                        if (props.loading === false) {
                          if (products.length === 0) {
                            return null
                          }

                          return html`
                            <section
                              class="
                            sec-ProductCarousel
                            sec-Section
                            sec-Section-spacingTopLarge
                            sec-Section-spacingBottomLarge
                          "
                            >
                              <div class="sec-ProductCarousel_Inner">
                                <${templates.header} />

                                <div
                                  class="sec-ProductCarousel_Body"
                                  data-product-carousel-body
                                >
                                  <${templates.productList} />
                                </div>
                              </div>
                            </section>
                          `
                        }
                      },
                    },
                    header: {
                      render: (html, args) => {
                        const props = args.props
                        const heading = props.helpers.getAPIResponse().name

                        return html`
                          <header
                            class="sec-ProductCarousel_Header sec-Section_Header"
                          >
                            <h3 class="sec-ProductCarousel_Title fz-15_120">
                              ${heading}
                            </h3>
                          </header>
                        `
                      },
                    },
                    productList: {
                      render: (html, args) => {
                        const { templates, props } = args
                        const { helpers } = props
                        const products = helpers.getProducts()

                        return html`
                          <grab-scroll
                            class="sec-ProductCarousel_Carousel"
                            data-cursor="grab"
                          >
                            <div
                              class="sec-ProductCarousel_Items"
                              aria-hidden="false"
                              data-product-carousel-items-default
                            >
                              ${products.map(
                                (product, index) =>
                                  html`
                                    <div class="sec-ProductCarousel_Item">
                                      <${templates.productCard}
                                        key=${index}
                                        product=${product}
                                        classModifier="searchResults"
                                        mobileViewport="50vw"
                                        desktopViewport="33vw"
                                      />
                                    </div>
                                  `,
                              )}
                            </div>
                          </grab-scroll>
                        `
                      },
                    },
                    productCard: {
                      render: (html, args) => {
                        return new ProductCard(html, args, this.translations)
                      },
                    },
                  },
                },
              },
            ],
          },
          render: this.renderNoResults.bind(this),
        },
        header: {
          render: this.renderHeader.bind(this),
        },
        heading: {
          render: this.renderHeading.bind(this),
        },
        headerSort: {
          render: this.renderHeaderSort.bind(this),
        },
        layoutControl: {
          render: this.renderLayoutControl.bind(this),
        },
        fixedBar: {
          render: this.renderFixedBar.bind(this),
        },
        filters: {
          options: {
            collapsible: false,
            includeSortOptionsInFilters: true,
            autoCollapse: false,
            showAppliedFilters: true,
            showClearAllFilters: true,
            showClearActionForIndividualFilters: true,
            showMatchingProductsCount: true,
            defaultExpandedFilters: [],
            showFiltersInDrawer: false,
          },
          render: this.renderFilters.bind(this),
        },
        filtersHeader: {
          render: this.renderFiltersHeader.bind(this),
        },
        filtersBody: {
          render: this.renderFiltersBody.bind(this),
        },
        filtersFooter: {
          render: this.renderFiltersFooter.bind(this),
        },
        activeFacets: {
          render: this.renderActiveFacets.bind(this),
        },
        activeFacet: {
          render: this.renderActiveFacet.bind(this),
        },
        activeRangeFacet: {
          render: this.renderActiveRangeFacet.bind(this),
        },
        filtersFacets: {
          render: this.renderFiltersFacets.bind(this),
        },
        filter: {
          render: this.renderFilter.bind(this),
        },
        filterHeader: {
          render: this.renderFilterHeader.bind(this),
        },
        filterItems: {
          render: this.renderFilterItems.bind(this),
        },
        priceRange: {
          render: this.renderPriceRange.bind(this),
        },
        facetList: {
          render: this.renderFacetList.bind(this),
        },
        sortOptionList: {
          render: this.renderSortOptionList.bind(this),
        },
        productList: {
          render: this.renderProductList.bind(this),
        },
        productCard: {
          render: this.renderProductCard.bind(this),
        },
        footer: {
          render: this.renderFooter.bind(this),
        },
        pagination: {
          options: {
            infiniteScroll: true,
          },
          render: this.renderPagination.bind(this),
        },
      },
      callbacks: {
        beforeAPICall: this.beforeAPICall.bind(this),
        afterInitialRender: this.afterInitialRender.bind(this),
      },
    })
  }

  beforeAPICall (requestParams) {
    getElements('details')?.forEach(detailsEl => {
      this.detailsStates[detailsEl.dataset.index] = detailsEl.open
    })

    return requestParams
  }

  afterInitialRender () {
    this.els.inner.element.setAttribute('aria-hidden', 'true')
  }

  renderSearchResults (html, args) {
    const { props, templates } = args
    const { helpers } = props

    window.BAO = window.BAO || {}
    window.BAO.Tagalys = window.BAO.Tagalys || {}
    window.BAO.Tagalys.helpers = helpers

    this.filterDrawerOpen = document.body.matches(
      '.drw-Drawers-search-filters.util-DrawersOpen',
    )

    this.setAttribute('aria-busy', helpers.isInitialLoading())

    if (helpers.isInitialLoading()) return

    return html`
      <${templates.body} />
    `
  }

  renderLoader (html) {
    return html`
      <div class="clc-ProductGrid_Loading">
        <svg
          viewBox="0 0 38 38"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          aria-hidden="true"
        >
          <defs>
            <linearGradient
              x1="8.042%"
              y1="0%"
              x2="65.682%"
              y2="23.865%"
              id="pagination-loading-icon-a"
            >
              <stop
                stop-color="currentColor"
                stop-opacity="0"
                offset="0%"
              ></stop>
              <stop
                stop-color="currentColor"
                stop-opacity=".631"
                offset="63.146%"
              ></stop>
              <stop stop-color="currentColor" offset="100%"></stop>
            </linearGradient>
          </defs>

          <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
            <path
              d="M36 18c0-9.94-8.06-18-18-18"
              stroke="url(#pagination-loading-icon-a)"
              stroke-width="2"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite"
              ></animateTransform>
            </path>

            <circle fill="currentColor" cx="36" cy="18" r="1">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
        </svg>
      </div>
    `
  }

  renderBody (html, args) {
    const { templates, props } = args
    const { helpers } = props

    return html`
      <div class="clc-ProductGrid_Inner">
        <desktop-fixed-bar class="clc-ProductGrid_Header">
          <${templates.header} />
        </desktop-fixed-bar>

        <${templates.fixedBar} />

        <div
          class="clc-ProductGrid_Body"
          data-desktop-fixed-bar-external-el="grid-body"
          data-fixed-bar-external-el="grid-body"
        >
          <div class="clc-ProductGrid_FacetsTarget">
            <div class="clc-ProductGrid_Products">
              <div class="prd-List">
                <ul class="prd-List_Items">
                  <${templates.productList} />
                </ul>

                ${!helpers?.getProducts()?.length
                  ? html`
                      <${templates.noResultsWidgets} />
                    `
                  : ''}
              </div>
            </div>
          </div>
        </div>

        <div class="clc-ProductGrid_Footer lyt-Container">
          <${templates.footer} />
        </div>

        <${templates.filters} />
      </div>
    `
  }

  renderNoResults (html, args) {
    const { templates, props } = args
    const { helpers } = props
    const noResultsText = helpers.hasAnyFiltersApplied()
      ? this.translations?.collection_template?.empty_with_filters
      : this.translations?.collection_template?.empty

    return html`
      <li class="prd-List_Item prd-List_Item-empty">
        <div class="clc-ProductGrid_Empty rte-RichText fz-15_120">
          <p class="clc-ProductGrid_Text">
            ${noResultsText}
          </p>

          <${templates.noResultsWidgets} />
        </div>
      </li>
    `
  }

  renderHeader (html, args) {
    const { props, templates } = args
    const { helpers } = props

    if (helpers.isInitialLoading()) return

    return html`
      <header class="clc-ProductGridHeader">
        <div class="clc-ProductGridHeader_Inner lyt-Container">
          <div class="clc-ProductGridHeader_Body">
            <div
              class="clc-ProductGridHeader_Column clc-ProductGridHeader_Column-left"
            >
              <${templates.heading} />
            </div>

            <div
              class="clc-ProductGridHeader_Column clc-ProductGridHeader_Column-right"
            >
              <div class="clc-ProductGridHeader_Facets">
                <button
                  class="clc-ProductGridHeader_FacetsTrigger"
                  type="button"
                  data-drawers-trigger="search-filters"
                  aria-controls="search-filters-drawer"
                  aria-expanded="false"
                >
                  ${this.translations?.collection_template?.filter_button}
                  <span class="clc-ProductGridHeader_FilterCount"
                    >(${helpers.getFilters()?.length})</span
                  >
                </button>
              </div>

              <${templates.headerSort} />
              <${templates.layoutControl} />
            </div>
          </div>
        </div>
      </header>
    `
  }

  renderHeaderSort (html, args) {
    const { props } = args
    const { helpers } = props

    const sortOptions = helpers.getSortOptions()

    if (!sortOptions?.length) return

    const handleSortChange = event => {
      helpers.applySortOption(event.target.value)
    }

    return html`
      <div class="clc-ProductGridHeader_Sort">
        <div class="clc-ProductGridHeader_SortControl">
          <label class="clc-ProductGridHeader_SortLabel" for="SortBy">
            ${this.translations?.collection_template?.sort}
          </label>

          <select
            name="sort_by"
            class="clc-ProductGridHeader_SortSelect"
            id="SortBy-toolbar"
            aria-describedby="a11y-refresh-page-message"
            onChange=${handleSortChange}
          >
            ${sortOptions.map(
              sortOption =>
                html`
                  <option
                    selected="${sortOption.selected}"
                    value="${sortOption.id}"
                    >${sortOption.label}</option
                  >
                `,
            )}
          </select>
        </div>
      </div>
    `
  }

  renderLayoutControl (html) {
    return html`
      <layout-control
        class="clc-ProductGridHeader_Layout"
        stored-layout-key="${this.translations?.layout_key}"
      >
        <button
          class="clc-ProductGridHeader_LayoutButton util-FocusRing"
          type="button"
          aria-current="false"
          data-layout-key="showless"
          aria-label="${this.translations?.collection_template
            ?.show_less_products_per_row}"
        >
          <span
            class="clc-ProductGridHeader_Icon clc-ProductGridHeader_Icon-mobile"
          >
            <html-renderer data-selector="#showless-mobile"></html-renderer>
          </span>

          <span
            class="clc-ProductGridHeader_Icon clc-ProductGridHeader_Icon-desktop"
          >
            <html-renderer data-selector="#showless-desktop"></html-renderer>
          </span>
        </button>

        <button
          class="clc-ProductGridHeader_LayoutButton util-FocusRing"
          type="button"
          aria-current="true"
          data-layout-key="showmore"
          aria-label="${this.translations?.collection_template
            ?.show_more_products_per_row}"
        >
          <span
            class="clc-ProductGridHeader_Icon clc-ProductGridHeader_Icon-mobile"
          >
            <html-renderer data-selector="#showmore-mobile"></html-renderer>
          </span>

          <span
            class="clc-ProductGridHeader_Icon clc-ProductGridHeader_Icon-desktop"
          >
            <html-renderer data-selector="#showmore-desktop"></html-renderer>
          </span>
        </button>
      </layout-control>
    `
  }

  renderFixedBar (html, args) {
    const { templates } = args

    return html`
      <fixed-bar class="clc-ProductGridFixedBar" aria-hidden="false">
        <div class="clc-ProductGridFixedBar_Inner">
          <div class="clc-ProductGridFixedBar_Body">
            <div class="clc-ProductGridFixedBar_Facets">
              <button
                class="clc-ProductGridFixedBar_FacetsTrigger btn-Button btn-Button-inline"
                type="button"
                data-drawers-trigger="search-filters"
                aria-controls="search-filters-drawer"
              >
                ${this.textContent(
                  this.translations?.collection_template?.filter_and_sort,
                )}

                <span class="clc-ProductGridFixedBar_Icon">
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <use href="#icon-plus"></use>
                  </svg>
                </span>
              </button>
            </div>

            <div class="clc-ProductGridFixedBar_Active">
              <${templates.activeFacets} />
            </div>
          </div>
        </div>
      </fixed-bar>
    `
  }

  renderHeading (html, args) {
    const { helpers } = args.props

    const productCount = helpers.getTotalProductsCount()
    const searchTerm = helpers.getQuery()

    if (helpers?.isSpellingCorrectedQuery()) {
      this.headingHTML = translateString(
        this.translations?.collection_template
          ?.spelling_corrected_results_found_for_html,
        {
          count: productCount,
          original_term: helpers?.getOriginalQuery(),
          term: searchTerm,
        },
      )
    } else if (helpers?.isPartialResults()) {
      this.headingHTML = translateString(
        this.translations?.collection_template?.partical_results_found_for_html,
        { count: productCount, term: searchTerm },
      )
    } else {
      this.headingHTML = translateString(
        this.translations?.collection_template?.results_found_for_html,
        { count: productCount, term: searchTerm },
      )
    }

    return html`
      <h1 class="clc-ProductGridHeader_Title fz-15_140">
        <html-renderer data-property-value="headingHTML"></html-renderer>
      </h1>
    `
  }

  renderFilters (html, args) {
    const { templates } = args

    return html`
      <site-drawer
        class="drw-Drawer drw-Drawer-fromRight ${this.filterDrawerOpen
          ? 'drw-Drawer-active'
          : ''}"
        data-key="search-filters"
        id="search-filters-drawer"
        role="dialog"
        aria-modal="true"
        aria-labelledby="search-filters-title"
      >
        <div class="drw-Drawer_Inner">
          <div class="drw-Drawer_Body">
            <div class="clc-ProductGridFacets clc-ProductGridFacets-search">
              <${templates.filtersHeader} />
              <${templates.filtersBody} />
              <${templates.filtersFooter} />
            </div>
          </div>
        </div>
      </site-drawer>
    `
  }

  renderFiltersHeader (html) {
    return html`
      <div class="clc-ProductGridFacets_Header">
        <h4
          class="clc-ProductGridFacets_Title fz-18_120"
          id="search-filters-title"
        >
          ${this.translations?.collection_template?.filter_title}
        </h4>

        <button
          type="button"
          class="clc-ProductGridFacets_Close util-FocusRing"
          data-drawers-close
        >
          <span class="util-ScreenReaderOnly">
            ${this.translations?.accessibility?.close}
          </span>

          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <use href="#icon-close"></use>
          </svg>
        </button>
      </div>
    `
  }

  renderFiltersBody (html, args) {
    const { templates } = args

    return html`
      <div class="clc-ProductGridFacets_Body">
        <div class="clc-ProductGridFacets_Active">
          <${templates.activeFacets} />
        </div>

        <div class="clc-ProductGridFacets_Facets">
          <${templates.filtersFacets} />
        </div>
      </div>
    `
  }

  renderFiltersFooter (html) {
    return html`
      <footer class="clc-ProductGridFacets_Footer">
        <button
          class="clc-ProductGridFacets_Button btn-Button btn-Button-secondary btn-Button-full"
          data-drawers-close
        >
          ${this.translations?.collection_template?.view_products}
        </button>
      </footer>
    `
  }

  renderActiveFacets (html, args) {
    const { props, templates } = args
    const { helpers } = props

    const appliedFilters = helpers.getAppliedFilters(true)
    if (!appliedFilters?.length) return ''

    return html`
      <div class="clc-ProductGridFacets_ActiveFacets fz-11_140">
        ${appliedFilters.map(appliedFilter => {
          if (appliedFilter.type === 'range') {
            return html`
              <${templates.activeRangeFacet} appliedFilter=${appliedFilter} />
            `
          } else {
            return html`
              ${appliedFilter?.items.map(
                filterItem =>
                  html`
                    <${templates.activeFacet}
                      filterItem=${filterItem}
                      appliedFilter=${appliedFilter}
                    />
                  `,
              )}
            `
          }
        })}

        <div
          class="clc-ProductGridFacets_ActiveFacet clc-ProductGridFacets_ActiveFacet-clear"
        >
          <button
            class="btn-Button btn-Button-inline fz-15_140"
            aria-label="${this.translations?.collection_template
              ?.clear_all_filters}"
            onClick=${helpers.clearAllFilters}
          >
            ${this.translations?.collection_template?.clear_all}
          </button>
        </div>
      </div>
    `
  }

  renderActiveFacet (html, args) {
    const { props } = args
    const { helpers, appliedFilter, filterItem } = props

    const handleClick = (filter, filterItem) => {
      helpers.clearFilter(filter.id, filterItem.id)
    }

    return html`
      <div class="clc-ProductGridFacets_ActiveFacet">
        <button
          class="clc-ProductGridFacets_ActiveLink"
          aria-label="${this.translations?.collection_template
            ?.clear_filter}: ${appliedFilter.name} - ${filterItem.name}"
          onClick=${() => {
            handleClick(appliedFilter, filterItem)
          }}
        >
          ${filterItem.name}

          <span class="clc-ProductGridFacets_Icon">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <use href="#icon-close"></use>
            </svg>
          </span>
        </button>
      </div>
    `
  }

  renderActiveRangeFacet (html, args) {
    const { props } = args
    const { helpers, appliedFilter } = props

    return html`
      <div class="clc-ProductGridFacets_ActiveFacet">
        <button
          class="clc-ProductGridFacets_ActiveLink"
          aria-label="${this.translations?.collection_template
            ?.clear_filter}: ${appliedFilter.name}"
          onClick=${() => helpers.clearFilter(appliedFilter.id)}
        >
          ${helpers.labelFormatter(
            appliedFilter.display_format,
            appliedFilter.selected_min,
            appliedFilter.currency,
          )}
          -
          ${helpers.labelFormatter(
            appliedFilter.display_format,
            appliedFilter.selected_max,
            appliedFilter.currency,
          )}

          <span class="clc-ProductGridFacets_Icon">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <use href="#icon-close"></use>
            </svg>
          </span>
        </button>
      </div>
    `
  }

  renderFiltersFacets (html, args) {
    const { props, templates } = args
    const { helpers } = props
    const filters = helpers.getFilters()
    const sortOptions = helpers.getSortOptions()

    return html`
      <div class="clc-ProductGridFacets_Items">
        ${filters.map(
          filter =>
            html`
              <div class="clc-ProductGridFacets_Item">
                <${templates.filter} filter=${filter} />
              </div>
            `,
        )}

        <div class="clc-ProductGridFacets_Item">
          <${templates.filter} sortOptions=${sortOptions} />
        </div>
      </div>
    `
  }

  renderFilter (html, args) {
    const { props, templates } = args
    const name = props?.filter
      ? props.filter.name
      : this.translations?.collection_template?.sort

    if (!props?.filter && !props?.sortOptions?.length) return

    return html`
      <details
        class="clc-ProductGridFacet clc-ProductGridFacet-${name
          .toLowerCase()
          .replace(/[^a-z0-9]/gi, '-')}"
        is="filter-facet"
        data-index="${name}"
        open=${!!this.detailsStates?.[name]}
      >
        <summary
          class="clc-ProductGridFacet_Summary"
          data-filter-facet-el="summary"
        >
          <${templates.filterHeader} name=${name} />
        </summary>

        <div
          class="clc-ProductGridFacet_Display"
          data-filter-facet-el="content"
        >
          <div class="clc-ProductGridFacet_Body">
            <${templates.filterItems} filter=${props.filter} />
            <${templates.filterItems} sortOptions=${props.sortOptions} />
          </div>
        </div>
      </details>
    `
  }

  renderFilterHeader (html, args) {
    return html`
      <span class="clc-ProductGridFacet_FilterLabel">
        ${args.props.name}
      </span>

      <span class="clc-ProductGridFacet_Icon clc-ProductGridFacet_Icon-plus">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          height="10"
          width="10"
        >
          <use href="#icon-plus"></use>
        </svg>
      </span>

      <span class="clc-ProductGridFacet_Icon clc-ProductGridFacet_Icon-minus">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          height="10"
          width="10"
        >
          <use href="#icon-minus"></use>
        </svg>
      </span>
    `
  }

  renderFilterItems (html, args) {
    const { props, templates } = args
    const { helpers, filter, sortOptions } = props

    const filterId = sortOptions?.length ? 'sort' : filter?.id
    const appliedFilters = helpers.getAppliedFilters(true)
    const appliedFilter = appliedFilters.find(appliedFilter =>
      appliedFilter.id === filterId ? appliedFilter : null,
    )

    if (filter?.type === 'range') {
      return html`
        <${templates.priceRange}
          filter=${filter}
          filterId=${filterId}
          appliedFilter=${appliedFilter}
        />
      `
    } else if (filter?.items?.length) {
      return html`
        <${templates.facetList}
          filter=${filter}
          filterId=${filterId}
          appliedFilter=${appliedFilter}
        />
      `
    } else if (sortOptions?.length) {
      return html`
        <${templates.sortOptionList}
          sortOptions=${sortOptions}
          filterId=${filterId}
        />
      `
    }
  }

  renderPriceRange (html, args) {
    const { props } = args
    const { filter, filterId, appliedFilter } = props

    const selectedMin = appliedFilter?.selected_min || ''
    const selectedMax = appliedFilter?.selected_max || ''

    const defaultMin = selectedMin?.length ? selectedMin : 0
    const defaultMax = selectedMax?.length ? selectedMax : filter.max

    return html`
      <tagalys-search-price-range
        class="prc-Range"
        filter-id="${filterId}"
        default-min="${defaultMin}"
        default-max="${defaultMax}"
      >
        <div class="prc-Range_Column">
          <span class="prc-Range_Symbol">
            ${this.translations?.currency?.symbol}
          </span>

          <div class="prc-Range_Field">
            <input
              class="prc-Range_Input"
              name="${filterId}-GTE"
              id="${filterId}-GTE"
              defaultValue=${selectedMin}
              type="number"
              placeholder="${defaultMin}"
              min="0"
              max="${selectedMax?.length ? selectedMax : filter.max}"
              step="1"
              data-tagalys-search-price-range-el="min"
            />

            <label class="prc-Range_Label" for="${filterId}-GTE">
              ${this.translations?.collection_template?.from}
            </label>
          </div>
        </div>

        <div class="prc-Range_Column">
          <span class="prc-Range_Symbol">
            ${this.translations?.currency?.symbol}
          </span>

          <div class="prc-Range_Field">
            <input
              class="prc-Range_Input"
              name="${filterId}-LTE"
              id="${filterId}-LTE"
              defaultValue=${selectedMax}
              type="number"
              min="${selectedMin
                ? Number(selectedMin) + 1
                : Number(filter.min) + 1}"
              placeholder="${defaultMax}"
              max="${filter.max}"
              step="1"
              data-tagalys-search-price-range-el="max"
            />

            <label class="prc-Range_Label" for="${filterId}-LTE">
              ${this.translations?.collection_template?.to}
            </label>
          </div>
        </div>
      </tagalys-search-price-range>
    `
  }

  renderFacetList (html, args) {
    const { props } = args
    const { filter, filterId, appliedFilter, helpers } = props

    const handleFacetChange = function (event, helpers, filter, filterItem) {
      if (filterItem?.selected) {
        helpers.clearFilter(filter.id, filterItem.id)
        event.target.setAttribute('aria-checked', !filterItem?.selected)
      } else {
        helpers.applyFilter(filter.id, filterItem.id)
        event.target.setAttribute('aria-checked', filterItem?.selected)
      }
    }

    return html`
      <ul class="clc-ProductGridFacet_List">
        ${filter.items.map(filterItem => {
          const appliedFilterItem = appliedFilter?.items?.find(
            appliedFilterItem =>
              appliedFilterItem.id === filterItem.id ? appliedFilterItem : null,
          )
          const isSelected = appliedFilterItem?.selected
          const hasResults = !!filterItem?.count

          return html`
            <li class="clc-ProductGridFacet_Item">
              <label
                class="clc-ProductGridFacet_Label clc-ProductGridFacet_Label-checkbox fz-13_140"
                for="${filterId}_${filterItem.id}"
                aria-disabled="${!hasResults}"
              >
                <input
                  class="clc-ProductGridFacet_Checkbox"
                  type="checkbox"
                  name="${filter.id}"
                  id="${filterId}_${filterItem.id}"
                  aria-checked="${isSelected}"
                  onChange=${event =>
                    handleFacetChange(event, helpers, filter, filterItem)}
                />
                <span class="clc-ProductGridFacet_CheckboxIcon"></span>

                <span class="clc-ProductGridFacet_Name">
                  ${filterItem.name}

                  <span class="clc-ProductGridFacet_Sub">
                    (${filterItem.count})
                  </span>
                </span>
              </label>
            </li>
          `
        })}
      </ul>
    `
  }

  renderSortOptionList (html, args) {
    const { props } = args
    const { helpers, filterId } = props

    const selectedSortOption = helpers.getAppliedSortOption()

    return html`
      <ul class="clc-ProductGridFacet_List">
        ${props?.sortOptions.map(sortOption => {
          const isSelected = selectedSortOption?.id === sortOption.id

          return html`
            <li class="clc-ProductGridFacet_Item">
              <label
                class="clc-ProductGridFacet_Label clc-ProductGridFacet_Label-checkbox fz-13_140"
                for="${filterId}_${sortOption.id}"
              >
                <input
                  class="clc-ProductGridFacet_Checkbox"
                  type="checkbox"
                  name="${filterId}"
                  id="${filterId}_${sortOption.id}"
                  aria-checked="${isSelected}"
                  onChange=${() => helpers.applySortOption(sortOption.id)}
                />
                <span class="clc-ProductGridFacet_CheckboxIcon"></span>

                <span class="clc-ProductGridFacet_Name">
                  ${sortOption.label}
                </span>
              </label>
            </li>
          `
        })}
      </ul>
    `
  }

  renderProductList (html, args) {
    const { props, templates } = args
    const { helpers } = props

    const products = helpers.getProducts()

    if (!products?.length) {
      return html`
        <${templates.noResults} />
      `
    }

    return html`
      ${products.map(
        (product, index) =>
          html`
            <li
              id="Product-${product.id}"
              class="prd-List_Item"
              data-page="${helpers.getCurrentPage()}"
            >
              <${templates.productCard}
                key=${index}
                product=${product}
                classModifier="searchResults"
                mobileViewport="50vw"
                desktopViewport="33vw"
              />
            </li>
          `,
      )}
    `
  }

  renderProductCard (html, args) {
    return new ProductCard(html, args, this.translations)
  }

  renderFooter (html, args) {
    const { props, templates } = args
    const { helpers } = props

    const productCount = helpers.getProducts()?.length
    const totalProductCount = helpers.getTotalProductsCount()

    return html`
      <footer class="clc-ProductGridFooter">
        <div class="clc-ProductGridFooter_Inner lyt-Container">
          <div class="clc-ProductGridFooter_Body fz-15_140">
            <div class="clc-ProductGridFooter_Pagination">
              <div class="clc-ProductGridFooter_PaginationInner">
                <${templates.pagination} />
              </div>
            </div>

            <div class="clc-ProductGridFooter_Count" role="status">
              <p class="clc-ProductGridFooter_Text">
                ${translateString(
                  this.translations?.collection_template?.product_count,
                  { product_count: productCount, count: totalProductCount },
                )}
              </p>
            </div>

            <div class="clc-ProductGridFooter_BackToTop">
              <a class="clc-ProductGridFooter_Link" href="#MainContent">
                ${this.translations?.collection_template?.back_to_top}
              </a>
            </div>
          </div>
        </div>
      </footer>
    `
  }

  renderPagination (html, args) {
    const { props } = args
    const { helpers } = props

    if (!helpers.hasNextPage()) return

    return html`
      <nav class="pgn-Pagination">
        <button
          class="pgn-Pagination_Link"
          type="button"
          onClick=${helpers.loadNextPage}
        >
          ${helpers.isLoading()
            ? this.translations?.collection_template?.loading
            : translateString(
                this.translations?.collection_template?.load_more,
                { item_type: this.translations?.collection_template?.products },
              )}
        </button>
      </nav>
    `
  }

  textContent (string) {
    const doc = new DOMParser().parseFromString(string, 'text/html')
    return doc.documentElement.textContent
  }

  get searchTerm () {
    return new URLSearchParams(window.location.search)?.get('q')
  }

  get translations () {
    return window.theme.strings
  }
}

if (!customElements.get('tagalys-search')) {
  customElements.define('tagalys-search', TagalysSearch)
}

class HtmlRenderer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (
      this.propertyValueToRender?.length &&
      this.tagalysSearchEl?.[this.propertyValueToRender]
    ) {
      this.outerHTML = this.tagalysSearchEl[this.propertyValueToRender]
      return
    }

    if (this.selectorOfElementToRender?.length && this.elementToRender) {
      this.outerHTML = this.elementToRender?.outerHTML
    }
  }

  get elementToRender () {
    return getElement(this.selectorOfElementToRender, {
      context: this.tagalysSearchEl,
    })
  }

  get selectorOfElementToRender () {
    return this.getAttribute('data-selector')
  }

  get propertyValueToRender () {
    return this.getAttribute('data-property-value')
  }

  get tagalysSearchEl () {
    return this.closest('tagalys-search')
  }
}

if (!customElements.get('html-renderer')) {
  customElements.define('html-renderer', HtmlRenderer)
}

class TagalysSearchPriceRange extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (!this.hasRequiredAttributes || !this.hasRequiredElements) return

    this.handleChange = this.handleChange.bind(this)
    this.debouncedHandleChange = debounce(e => this.handleChange(e), 500)
    this.listeners.add(this, 'change', this.debouncedHandleChange.bind(this))
  }

  handleChange (event) {
    if (event.target.matches(this.els.min?.selector)) {
      this.selectedMin = Number(event.target.value)
    }

    if (event.target.matches(this.els.max?.selector)) {
      this.selectedMax = Number(event.target.value)
    }

    window.BAO.Tagalys.helpers.applyFilter(this.filterId, {
      selected_min: this.selectedMin,
      selected_max: this.selectedMax,
    })
  }

  set selectedMin (selectedMin) {
    this._selectedMin = selectedMin
  }

  set selectedMax (selectedMax) {
    this._selectedMax = selectedMax
  }

  get selectedMin () {
    return this._selectedMin || this.defaultMin
  }

  get selectedMax () {
    return this._selectedMax || this.defaultMax
  }

  get filterId () {
    return this.getAttribute('filter-id')
  }

  get defaultMin () {
    return Number(this.getAttribute('default-min'))
  }

  get defaultMax () {
    return Number(this.getAttribute('default-max'))
  }

  get hasRequiredAttributes () {
    return (
      this.hasAttribute('filter-id') &&
      this.hasAttribute('default-min') &&
      this.hasAttribute('default-max')
    )
  }

  get hasRequiredElements () {
    return this.els?.min?.element && this.els?.max?.element
  }
}

if (!customElements.get('tagalys-search-price-range')) {
  customElements.define('tagalys-search-price-range', TagalysSearchPriceRange)
}
